if (!customElements.get("collection-load-more")) {
  customElements.define(
    "collection-load-more",
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.changeUrl = this.dataset.changeUrl == "true";
        this.productGridSelector = "#product-grid";

        if (this.button) {
          this.button.addEventListener("click", this.handleButtonClick.bind(this));
        }
      }
      get button() {
        return this.querySelector("a");
      }

      get loadingSpinner() {
        return this.querySelector(".loading__spinner");
      }

      set loading(loading) {
        this._loading = loading;
        if (loading) {
          if (this.button) {
            this.button.classList.add("loading");
          }
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.remove("hidden");
          }
        } else {
          if (this.button) {
            this.button.classList.remove("loading");
          }
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add("hidden");
          }
        }
      }

      get loading() {
        return this._loading;
      }

      handleButtonClick(e) {
        e.preventDefault();
        if (this.children.length == 0) {
          return;
        }
        this.loadNextPage();
      }

      changePageInURL(pageNumber) {
        if (!this.changeUrl) return;
        if (pageNumber == undefined) return;

        let url = new URL(window.location);
        url.searchParams.set("page", pageNumber);
        window.history.pushState({}, "", url);
      }

      updateHrefs() {
        let productGrid = document.querySelector(this.productGridSelector);
        let productGridChildren = Array.from(productGrid.children);
        productGridChildren.forEach((child, index) => {
          let link = child.querySelector("a");
          if(link){
            let href = link.href;
            let urlObject = new URL(href);
            let pos = urlObject.searchParams.get("_pos");
            if (pos == null) {
              urlObject.searchParams.set("_pos", index);
              link.href = urlObject.href;
            }
          }
        });
      }

      afterRender() {
        //add any functions that need to be run after product grid render
        this.updateHrefs();
      }

      loadNextPage() {
        if (this.button == null) return;
        this.loading = true;

        let url = this.button.href;
        let urlObject = new URL(url);
        let nextPageNumber = urlObject.searchParams.get("page");

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            this.changePageInURL(nextPageNumber);
            const html = responseText;
            const parsedResponse = new DOMParser().parseFromString(html, "text/html");
            let productGrid = parsedResponse.querySelector(this.productGridSelector);
            let ogProductGrid = document.querySelector(this.productGridSelector);
            let productGridChildren = Array.from(productGrid.children);

            if (productGridChildren.length) {
              productGridChildren.forEach((child) => {
                let clonedChild = child.cloneNode(true);
                ogProductGrid.append(clonedChild);
              });
            }

            const ogLoadMoreButtons = document.querySelectorAll("collection-load-more a");
            const newLoadMoreSection = parsedResponse.querySelector("collection-load-more");

            this.afterRender();

            if (newLoadMoreSection) {
              let newLoadMoreButton = newLoadMoreSection.querySelector("a");
              ogLoadMoreButtons.forEach((button) => (button.href = newLoadMoreButton.href));
              this.loading = false;
            } else {
              ogLoadMoreButtons.forEach((button) => button.remove());
              this.loading = false;
            }
          });
      }
    }
  );
}
